import React from 'react';
import { Carousel } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';

const Travel = () => {

    const navigate = useNavigate();

    const Goback = () => {
        navigate('/home')
    }


    return (
        <div>
              <div className="container mt-5 pageColor">
                <h3 style={{cursor:"pointer"}} onClick={Goback} className="fs-4  text-white fw-bolder">← Back </h3>
                
                <h1 className="text-center p-5 text-white fw-bolder"> Travel World Agency .</h1>
               
{/* ------------------------------  */}
            
 <Carousel  style={{ textAlign:'center'}}  fade>
  <Carousel.Item className="container">
    <img
      className="d-block w-100"
      src="https://i.ibb.co/qsywzKH/tavel-3.png"
      alt="First slide"
    />
    <Carousel.Caption>
     
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/gMgfNcK/travel-2.png"
      alt="Second slide"
    />

    <Carousel.Caption>
     
    </Carousel.Caption>
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100"
      src="https://i.ibb.co/BypvSrD/travel-1.png"
      alt="Third slide"
    />

    <Carousel.Caption>
    </Carousel.Caption>
  </Carousel.Item>
 </Carousel>
{/* ------------------------------  */}

          <br />  
          <br />  
          <br />
          <h5 className="ps-2 text-white"> This is Travel Agency website . Technologies use : React js, Firebase, Bootstrap, React Router, Node js, Express Js, MongoDb  it's Fully Responsive . Live link Click here to visit the page: PH-Travel , Client side Github Link: Go to Github client side  repository .Thanks ....
        </h5>  
        
        <br />
            <div className=" grid-button d-flex justify-content-center p-5  ">
                    <a className= " box btn  text-primary    fw-bolder " href="https://github.com/RonyMiah/Travel-tourism-assinment-11-work-9"> Git-Hub client </a>
                        <a className=" box btn  text-primary    fw-bolder "  href="https://github.com/RonyMiah/Travel-tourism-server-side-assinment-11-work-9-" > Git-Hub server </a>
                        <a className=" box btn  text-primary    fw-bolder " href="https://ph-travel-1e00a.web.app/"> Live site </a>
                        <NavLink className=" box btn  text-primary    fw-bolder " to="/blogs"> Blogs </NavLink>
            </div>

        </div>
        </div>
    );
};

export default Travel;